import React from 'react'

import cn from '../../libs/class-names'

export interface Props {
  classNames?: string[]
  children: React.ReactNode
  note?: React.ReactNode
  type?: 'default' | 'warning' | 'minor' | 'error' | 'success'
}

const FieldNote = ({classNames, children, note, type = 'default'}: Props) => (
  <div className={cn('FieldNote', {[`type-${type}`]: true}, classNames)}>
    {children}
    {note && <div className="FieldNote__note">{note}</div>}
  </div>
)

export default FieldNote
